import { render } from "./ShippingInfo.vue?vue&type=template&id=44a9cd8f&scoped=true"
import script from "./ShippingInfo.vue?vue&type=script&lang=ts"
export * from "./ShippingInfo.vue?vue&type=script&lang=ts"

import "./ShippingInfo.vue?vue&type=style&index=0&id=44a9cd8f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44a9cd8f"

export default script